import React, { useState } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Container from "@material-ui/core/Container";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import CheckIcon from "@material-ui/icons/Check";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { callAPI } from "../../../../lib/common";
import MaterialTextField from "../../../../components/Formik/MaterialTextField";
import AppBar from "../../Components/AppBar";
import { useAuth } from "../../../providers/AuthProvider";
import LoadingButton from "../../../../components/LoadingButton";
import { getYUPValidators } from "../../../../components/yupvalidators";
import InputMobileNumber from "../../../Desktop/Pages/SubjectRegistration/Components/InputMobileNumber";
import { validateMobileNumberServerSide } from "../../../services/MobileNumberService";
import { usePortal } from "../../../../Providers/PortalProvider";

const useStyles = makeStyles(() => ({
  postalCodeCityContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  postalCode: {
    flexBasis: "40%",
  },
  form: {
    marginBottom: 0,
  },
  iconDone: {
    textAlign: "center",
    color: "green",
    "& .MuiSvgIcon-root": {
      fontSize: "3rem",
    },
  },
}));

const getValidationSchema = (t) => () => {
  const validators = getYUPValidators(t);
  return Yup.object().shape({
    name: validators.FULL_NAME,
    address: validators.ADDRESS,
    address2: validators.ADDRESS,
    postal_code: validators.POSTAL_CODE,
    city: validators.CITY,
    mobile: validators.MOBILE_PHONE_WITH_SERVER_VALIDATION,
  });
};

export default () => {
  const classes = useStyles();
  const [isUpdated, setIsUpdated] = useState(false);
  const { loadCurrentUser } = useAuth();

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    callAPI("/ajax/user/update_user_info.php", "POST", values)
      .then(() => {
        setSubmitting(false);
        setIsUpdated(true);
        loadCurrentUser();
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Update contact information</Trans>
      </PageHeader>
      <Container className={classes.root} maxWidth="sm">
        <Card>
          <CardContent>
            {isUpdated ? (
              <InfoUpdatedMessage />
            ) : (
              <ContactInfoForm handleSubmit={handleSubmit} />
            )}
          </CardContent>
        </Card>
      </Container>
    </MobilePage>
  );
};

const ContactInfoForm = ({ handleSubmit }) => {
  const [t] = useTranslation();
  const { user } = useAuth();
  const classes = useStyles();
  const portal = usePortal();
  const { gatherAddress2 } = portal.options;

  console.log("The user", user);

  return (
    <Formik
      initialValues={{
        name: user.name,
        address: user.address.address,
        address2: user.address.address2,
        postal_code: user.address.postalCode,
        city: user.address.city,
        mobile: user.mobilePhone,
      }}
      onSubmit={handleSubmit}
      validationSchema={getValidationSchema(t)}
      isInitialValid={false}
    >
      {({ isSubmitting, isValid }) => {
        return (
          <Form className={classes.form}>
            <Box mb={3}>
              <Field
                name="name"
                label={t("Full name")}
                component={MaterialTextField}
              />
              <Field
                name="address"
                label={t("Address")}
                component={MaterialTextField}
              />
              {gatherAddress2 && (
                <Field
                  name="address2"
                  label={t("Address 2")}
                  component={MaterialTextField}
                />
              )}
              <div className={classes.postalCodeCityContainer}>
                <Box mr={1} className={classes.postalCode}>
                  <Field
                    name="postal_code"
                    label={t("Postal code")}
                    component={MaterialTextField}
                  />
                </Box>
                <Box ml={1}>
                  <Field
                    name="city"
                    label={t("City")}
                    component={MaterialTextField}
                  />
                </Box>
              </div>
              <Box mt={3}>
                <Field
                  name="mobile"
                  label={t("Mobile phone")}
                  component={InputMobileNumber}
                  variant="standard"
                />
              </Box>
            </Box>
            <LoadingButton
              isLoading={isSubmitting}
              type="submit"
              variant="primary"
              fullWidth
              disabled={!isValid}
            >
              <Trans>Update information</Trans>
            </LoadingButton>
          </Form>
        );
      }}
    </Formik>
  );
};

const InfoUpdatedMessage = () => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.iconDone}>
        <CheckIcon />
      </div>
      <p>
        <Trans>Your contact info was successfully updated.</Trans>
      </p>
    </div>
  );
};
